import { render, staticRenderFns } from "./CommodityCostAdjustListDetail.vue?vue&type=template&id=18a08ef8&scoped=true&"
import script from "./CommodityCostAdjustListDetail.vue?vue&type=script&lang=js&"
export * from "./CommodityCostAdjustListDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommodityCostAdjustListDetail.vue?vue&type=style&index=0&id=18a08ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a08ef8",
  null
  
)

export default component.exports